import {Sprout,Footprints,Binoculars,Compass,Route,BookOpen,Crown} from 'lucide-react';
import type {levels} from '../domain';
const icons={noob:Sprout,rookie:Footprints,scout:Binoculars,explorer:Compass,pathfinder:Route,sage:BookOpen,legend:Crown};
export function LevelBadge({level}:{level:typeof levels[number]}){
 const Icon=icons[level.badge];
 return <span className={'khoji-badge badge-'+level.badge} data-badge={level.badge} aria-hidden="true"><Icon size={23} strokeWidth={1.9}/><span className="badge-spark"/></span>;
}
